/* eslint-disable */
import React from 'react';
import {
  Container,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@material-ui/core';

import { CurrencyFormatter } from '../Utils/CurrencyFormatter';

function WidgetTile({ icon, topSubtitle, value, bottomSubtitle = '', backgroundBlue = true }) {
  const tileStyle = {
    background: backgroundBlue ? '#024788' : 'white',
    color: backgroundBlue ? 'white' : '#024788',
    height: '100%',
    padding: '20px 5px', // Ajusta el padding según tus necesidades
  };

  const contentStyle = {
    height: '100%',
  }

  const iconStyle = {
    color: backgroundBlue ? 'white' : '#024788',
  };

  const valueStyle = {
    fontSize: '24px',
    color: backgroundBlue ? 'white' : '#001930',
  };

  const topSubtitleStyle = {
    fontSize: '14px', // Cambia el tamaño del subtitulo top
    fontWeight: 600
  };

  const bottomSubtitleStyle = {
    fontSize: '12px', // Cambia el tamaño del subtitulo bottom
  };

  return (
    <Container component={Paper} style={tileStyle}>
      <ListItem style={contentStyle}>
        <ListItemIcon style={iconStyle}>
            {icon}
        </ListItemIcon>
        <ListItemText
          primary={
            <div>
              <div style={topSubtitleStyle}>{topSubtitle}</div>
              <div style={{ fontWeight: 'bold', ...valueStyle }}>
                {/* Aplicar formato al 'value' si es necesario */}
                <CurrencyFormatter value={value}/>  
              </div>
              <div style={bottomSubtitleStyle}>{bottomSubtitle}</div>
            </div>
          }
        />
      </ListItem>
    </Container>
  );
}

export default WidgetTile;
